import { create } from "zustand"

export default create((set) => (
	{
		totalRO: 0,
		setTotalRO: (number) => set((state) => ({
			totalRO: number
		})),


		unassignedRO: 0,
		setUnassignedRO: (number) => set((state) => ({
			unassignedRO: number
		})),

		jurisdictionName: 'Select a jurisdiction',
		setJurisdictionName: (name) => set((state) => ({
			jurisdictionName: name
		})),

		currentHuntUsers: [],
		setCurrentHuntUsers: (huntUsers) => set((state) => ({
			currentHuntUsers: huntUsers
		})),

		/* {
			id, quantity
		} */
		selectedHuntUsers: [],
		addSelectedHuntUser: (huntUser) => set((state) => {
			if (state.selectedHuntUsers.find((selectedHuntUser) => selectedHuntUser.id === huntUser.id)) {
				return {
					selectedHuntUsers: state.selectedHuntUsers.map((selectedHuntUser) => {
						if (selectedHuntUser.id === huntUser.id) {
							return {
								...selectedHuntUser,
								quantity: huntUser.quantity
							}
						}

						return selectedHuntUser
					})
				}
			} else {
				return {
					selectedHuntUsers: [
						...state.selectedHuntUsers,
						huntUser
					]
				}
			}
		}),
		removeSelectedHuntUser: (huntUser) => set((state) => ({
			selectedHuntUsers: state.selectedHuntUsers.filter((selectedHuntUser) => selectedHuntUser.id !== huntUser.id)
		})),
		setSelectedHuntUsers: (huntUsers) => set((state) => ({
			selectedHuntUsers: huntUsers
		})),
		resetSelectedHuntUsers: () => set((state) => ({
			selectedHuntUsers: []
		}))
	}
))
